import base64 from 'base-64'
import Cookies from 'js-cookie'

export const TOKEN = 'token'
export const EXPIRES_ON = 'expires_on'
export const EXPIRES_DATE = 'expires_date'
export const USER_ID = 'user_id'
export const FULL_NAME = "fullname"
export const ROLE = "role"
export const EMAIL = "email"
export const O365_TOKEN = "o365_token"
export const USER_IMAGE = "user_image"
export const IS_NPI_ADMIN = "is_npi_admin"
export const IS_ADMIN = "is_admin"
export const SYSTEM_INFO = "system_info"
export const IS_ADMIN_TRAINING = "is_admin_training"
export const IS_ADMIN_CAR_RESERVATION = "is_admin_car_reservation"
export const EMP_ID = "emp_id"
export const IS_ACCESS_MY_TRACKER = "is_access_my_tracker"
export const IS_ACCESS_MY_TRAINING = "is_access_my_tracker"
export const IS_ACCESS_MY_CAR_RESERVATION = "is_access_my_car_reservation"
export const MODULES = "modules"

function getCookie(key) {
    try {
        const value = Cookies.get(key)
        let setValue = ''

        if (value && typeof value === 'string') {
            setValue = base64.decode(value)
        }

        return setValue
    } catch (error) {
        return null
    }

}

function setCookie(key, value, expires) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    if (expires && typeof expires === "number" && expires > 0) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }

}

function removeCookie(key) {
    Cookies.remove(key)
}

export function authentication(dataAuth, isRemember) {
    console.log("authentication", dataAuth)
    const { user: { email, fullName, id, isNpiAdmin, isAdmin, isAdminTrainingCourse, empId }, token, expiresDate, expiresOn, modules } = dataAuth

    clearToken()
    setCookie(FULL_NAME, fullName)
    setCookie(EMAIL, email)
    setCookie(USER_ID, id)
    setCookie(EMP_ID, empId)
    setCookie(TOKEN, token)
    setCookie(EXPIRES_DATE, expiresDate)
    setCookie(EXPIRES_ON, expiresOn)
    setCookie(IS_NPI_ADMIN, isNpiAdmin)
    setCookie(IS_ADMIN, isAdmin)
    setCookie(IS_ADMIN_TRAINING, isAdminTrainingCourse)
    setCookie(MODULES, modules)
}
export function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data)
}
export function getO365Token() {
    return getCookie(O365_TOKEN)
}
export function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data)
}
export function getUserImageCookie() {
    return getCookie(USER_IMAGE)
}
export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(EXPIRES_DATE)
    removeCookie(USER_ID)
    removeCookie(EMP_ID)
    removeCookie(FULL_NAME)
    removeCookie(EMAIL)
    removeCookie(IS_ADMIN)
    removeCookie(IS_NPI_ADMIN)
    removeCookie(IS_ADMIN_TRAINING)
    removeCookie(IS_ADMIN_CAR_RESERVATION)
    removeCookie(MODULES)
}
export function getAllCookies() {
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [EXPIRES_DATE]: getCookie(EXPIRES_DATE),
        [USER_ID]: getCookie(USER_ID),
        [IS_NPI_ADMIN]: getCookie(IS_NPI_ADMIN),
        [IS_ADMIN]: getCookie(IS_ADMIN),
        [IS_ADMIN_TRAINING]: getCookie(IS_ADMIN_TRAINING),
        [IS_ADMIN_CAR_RESERVATION]: getCookie(IS_ADMIN_CAR_RESERVATION),
        [EMP_ID]: getCookie(EMP_ID),
        [MODULES]: getCookie(MODULES)
    }
}
export function getModules() {
    return getCookie(MODULES)
}
export function getToken() {
    return getCookie(TOKEN)
}
export function getUserId() {
    return getCookie(USER_ID)
}
export function getFullName() {
    return getCookie(FULL_NAME)
}
export function getEmail() {
    return getCookie(EMAIL)
}
export function getRole() {
    return getCookie(ROLE)
}
export function getExpireDate() {
    return getCookie(EXPIRES_DATE)
}
export function getIsNpiAdmin() {
    return getCookie(IS_NPI_ADMIN)
}
export function getIsAdminTraining() {
    return getCookie(IS_ADMIN_TRAINING)
}
export function getIsAdminCarReservation() {
    return getCookie(IS_ADMIN_CAR_RESERVATION)
}
export function getIsAdmin() {
    return getCookie(IS_ADMIN)
}

export function getIsAccessMyTracker() {
    return getCookie(IS_ACCESS_MY_TRACKER)
}

export function getIsAccessMyTraining() {
    return getCookie(IS_ACCESS_MY_TRAINING)
}

export function getIsAccessMyCarReservation() {
    return getCookie(IS_ACCESS_MY_CAR_RESERVATION)
}
export function setSystemInfo(data) {
    // setCookie(SYSTEM_INFO, data)
    Cookies.set(SYSTEM_INFO, data)
}
export function getSystemInfo() {
    return getCookie(SYSTEM_INFO)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js